import React from 'react';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../../common/SafeIcon';

const { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaTiktok, FaWhatsapp } = FaIcons;

export default function Footer() {
  const BOOKING_URL = "https://link.nordiccrm.ca/widget/bookings/dorman-ernest-baltazar-personal-calendar-qg2bbc8wa";
  
  const socialLinks = [
    { icon: FaFacebookF, url: "https://www.facebook.com/Onelove4us", label: "Facebook" },
    { icon: FaInstagram, url: "https://instagram.com/dorman.baltazar", label: "Instagram" },
    { icon: FaYoutube, url: "https://youtube.com/@nova-collective-f6c", label: "YouTube" },
    { icon: FaLinkedinIn, url: "https://linkedin.com/in/dormanbaltazar", label: "LinkedIn" },
    { icon: FaTiktok, url: "https://tiktok.com/@dormanbaltazar", label: "TikTok" },
    { icon: FaWhatsapp, url: "https://api.whatsapp.com/send?phone=13062511253", label: "WhatsApp" }
  ];

  return (
    <footer className="bg-kin-black border-t border-kin-ivory/5 pt-32 pb-16 px-6 md:px-12 relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-kin-gold/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-16 border-b border-kin-ivory/10 pb-20 relative z-10">
        
        <div className="max-w-md">
          <Link to="/" className="block mb-8 transition-transform hover:scale-105 duration-500 ease-out origin-left">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvanBlZw==/68d6537db3932682a335733b6ae3e309.jpeg" 
              alt="Kingdom Inspira Nova" 
              className="h-20 md:h-24 w-auto object-contain rounded-md"
            />
          </Link>
          <p className="text-kin-ivory/50 leading-relaxed font-light text-sm tracking-wide">
            Identity Before Income. A modern philosophy and creator development brand helping leaders build aligned, sustainable, purpose-driven lives.
          </p>
        </div>

        <div className="flex gap-20">
          <div className="flex flex-col space-y-6">
            <h4 className="font-serif text-kin-gold tracking-widest uppercase text-xs">Ecosystem</h4>
            <Link to="/about" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">About</Link>
            <Link to="/speaking" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">Speaking Engagements</Link>
            <Link to="/blueprint" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">Blueprint</Link>
            <Link to="/thrive" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">THRIVE</Link>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">Discovery Call</a>
          </div>

          <div className="flex flex-col space-y-6">
            <h4 className="font-serif text-kin-gold tracking-widest uppercase text-xs">Connect</h4>
            <Link to="/resources" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">Resources</Link>
            <Link to="/contact" className="text-kin-ivory/50 hover:text-kin-ivory transition-colors text-sm tracking-wide">Contact</Link>
            
            <div className="grid grid-cols-3 gap-6 mt-2">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-kin-ivory/40 hover:text-kin-gold transition-colors duration-300 transform hover:scale-110"
                  aria-label={social.label}
                >
                  <SafeIcon icon={social.icon} className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>

      <div className="max-w-7xl mx-auto mt-12 flex flex-col md:flex-row justify-between items-center text-[10px] uppercase text-kin-ivory/30 tracking-[0.2em] relative z-10">
        <p>© {new Date().getFullYear()} Kingdom Inspira Nova Studio.</p>
        <div className="flex space-x-8 mt-6 md:mt-0">
          <Link to="/privacy" className="hover:text-kin-ivory/70 transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-kin-ivory/70 transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}